import { render, staticRenderFns } from "./CoachMenu.vue?vue&type=template&id=747c809a&"
import script from "./CoachMenu.vue?vue&type=script&lang=js&"
export * from "./CoachMenu.vue?vue&type=script&lang=js&"
import style0 from "./CoachMenu.vue?vue&type=style&index=0&id=747c809a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VChip,VListItemGroup,VMenu,VSubheader})
